import "@/v2/styles/main.scss";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import { createApp } from "vue";
import withUUID from "vue-uuid";
import App from "@/App.vue";

import { addPlugins } from "@/setup/addPlugins.js";
import { addIcons } from "@/setup/addIcons.js";
import initializeDatadogRum from "@/setup/initializeDatadogRum.ts";
import { BODY_TARGET_IDS } from "@/util/constants.ts";
import customWarnHandler from "@/setup/customWarnHandler.ts";

const app = withUUID(createApp(App));

addPlugins(app);
addIcons(app);
customWarnHandler(app);
app.mount(`#${BODY_TARGET_IDS.appTarget}`);
initializeDatadogRum(app);
